import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-智能审图",
  "use": "icon-智能审图-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-智能审图\">\r\n<g>\r\n\t<path d=\"M172.4,23.2H27.6c-9.8,0-17.6,7.9-17.6,17.5v118.4c0,9.8,7.9,17.6,17.6,17.6h144.8c9.7,0,17.6-8,17.6-17.6V40.7\r\n\t\tC190,31.1,182.1,23.2,172.4,23.2z M178.3,159.2c0,3.2-2.7,5.9-5.9,5.9H27.6c-3.2,0-5.9-2.7-5.9-5.9v-22.9l28-15.6\r\n\t\tc1-0.6,2.4-0.6,3.4,0.1l23.3,13.5c5.6,3.3,12.7,2.6,17.6-1.7l27.9-24.2c1.1-1,2.7-1.1,4.1-0.4l52.2,32.3V159.2z M178.3,126.5\r\n\t\tL132.1,98c-5.7-3.5-12.9-2.9-17.9,1.4l-27.9,24.3c-1.1,0.9-2.7,1.1-4,0.4l-23.3-13.5c-4.6-2.7-10.3-2.7-15-0.2l-22.4,12.4v-82\r\n\t\tc0-3.2,2.7-5.8,5.9-5.8h144.8c3.2,0,5.9,2.7,5.9,5.9V126.5z\" />\r\n\t<path d=\"M75.8,49.8c-13.2,0-24,10.8-24,24c0,13.2,10.7,24,24,24c13.2,0,24-10.8,24-24C99.8,60.6,89,49.8,75.8,49.8z M75.8,86\r\n\t\tc-6.7,0-12.2-5.5-12.2-12.2c0-6.7,5.5-12.2,12.2-12.2s12.2,5.5,12.2,12.2C88.1,80.5,82.6,86,75.8,86z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/智能审图.svg
// module id = e+b4
// module chunks = 15